{
  "schemaVersion": 1,
  "shared": {
    "allowedHosts": [
      "27c7f95f-b199-4d85-ac54-e3724b4ed2d7-00-1jpxhiryv1ajf.pike.replit.dev",
      "ai-gateway.vercel.sh",
      "ai.52ccl.cn",
      "ai.gitee.com",
      "ai.littlesheep.cc",
      "ai.sefirah.online",
      "aigateway.sh",
      "aigc-llm.mgtv.com",
      "aihubmix.com",
      "aip.baidubce.com",
      "aiplatform.googleapis.com",
      "ananbdhdh.bond",
      "anandexiaowo.coffee",
      "api-inference.modelscope.cn",
      "api-yuan.replit.app",
      "api.01.ai",
      "api.360.cn",
      "api.ai21.com",
      "api.aihubmix.com",
      "api.aimlapi.com",
      "api.alayanew.com",
      "api.anthropic.com",
      "api.baichuan-ai.com",
      "api.baimeow.icu",
      "api.cetaceang.qzz.io",
      "api.cline.bot",
      "api.cohere.com",
      "api.deepinfra.com",
      "api.deepseek.com",
      "api.denxio.top",
      "api.edgefn.net",
      "api.fanzisima.xyz",
      "api.fireworks.ai",
      "api.githubcopilot.com",
      "api.goldenglow.us.ci",
      "api.groq.com",
      "api.hk.ocoolai.com",
      "api.hunyuan.cloud.tencent.com",
      "api.hyperbolic.xyz",
      "api.infini-ai.com",
      "api.inliver.com",
      "api.jina.ai",
      "api.lingyiwanwu.com",
      "api.minimax.io",
      "api.minimaxi.com",
      "api.mistral.ai",
      "api.momotale.com",
      "api.moonshot.ai",
      "api.moonshot.cn",
      "api.moyii.de",
      "api.my.ocoolai.com",
      "api.nanaaa.asia",
      "api.novelai.moe",
      "api.novelai.net",
      "api.ocoolai.com",
      "api.openai.com",
      "api.penguinsama.com",
      "api.perplexity.ai",
      "api.pioneer.ai",
      "api.poe.com",
      "api.ppinfra.com",
      "api.ppio.com",
      "api.primavera64.org",
      "api.qnaigc.com",
      "api.qwen.ai",
      "api.rokwuky.com",
      "api.shanhai.chat",
      "api.shanhaiai.top",
      "api.siliconflow.cn",
      "api.siliconflow.com",
      "api.sillytaverns.com",
      "api.stepfun.ai",
      "api.stepfun.com",
      "api.sunlea.de",
      "api.tianbohe.xyz",
      "api.tianbohe.xzy",
      "api.together.xyz",
      "api.us.ocoolai.com",
      "api.voyageai.com",
      "api.wananqwq.com",
      "api.wavespeed.ai",
      "api.x.ai",
      "api.xiejiang.de5.net",
      "api.yepapi.com",
      "api.youzi.today",
      "api.z.ai",
      "api4.orangeai.cc",
      "apihub.agnes-ai.com",
      "apihub.veletis.com",
      "apiw.lumilys.moe",
      "app.momotale.com",
      "ark-acg-cn-beijing.tos-cn-beijing.volces.com",
      "ark.cn-beijing.volces.com",
      "backent-catiecli.zeabur.app",
      "bufan.de5.net",
      "bufan.live",
      "casino.jnai2d9kgnbs6xzx5c.com",
      "cat.250073.xyz",
      "catiecli.sukaka.top",
      "cdn.moe-atelier.site",
      "cdn.wavespeed.ai",
      "chami.yyqzx.com",
      "claude.sonnet.net.cn",
      "cloud.infini-ai.com",
      "cn-hongkong.dashscope.aliyuncs.com",
      "code-generator-brianrobertson4.replit.app",
      "codex.rokwuky.com",
      "coding-intl.dashscope.aliyuncs.com",
      "dashscope-intl.aliyuncs.com",
      "dashscope-result-bj.oss-cn-beijing.aliyuncs.com",
      "dashscope-us.aliyuncs.com",
      "dashscope.aliyuncs.com",
      "deepseek.alayanew.com",
      "dify2api.sweet-home.io",
      "ds.sonnet.net.cn",
      "ds.xiaoming.uno",
      "echo.veletis.com",
      "fanzisima.xvz",
      "fast.kitakamis.online",
      "fuzhan.magicv4.ltd",
      "gcli.ggchan.dev",
      "gemini618-cloud.hf.space",
      "gen.pollinations.ai",
      "generativelanguage.googleapis.com",
      "gensoukyou.xyz",
      "ghostshellun.com",
      "goldenglow.webn.cc",
      "hanbaoyu.ggff.net",
      "hfuu.cdfeb.de",
      "hikaripublic.xyz",
      "huan.baby",
      "image.novelai.net",
      "image.pollinations.ai",
      "imagegen.mukyu.me",
      "integrate.api.nvidia.com",
      "ir-api.youzi.today",
      "ir.youzi.today",
      "juzixiaoguofan.replit.app",
      "kiro.fanzisima.xyz",
      "login.p1gment.icu",
      "lottery.tianbohe.xyz",
      "love.chenoodesu.online",
      "magicv4.ltd",
      "maidcat.coffee",
      "models.github.ai",
      "modelservice.jdcloud.com",
      "mukyu.me",
      "mukyu.xyz",
      "my.ocoolai.com",
      "na.xiaodu.best",
      "nano-gpt.com",
      "nasbawan.de5.net",
      "new.nasbawan",
      "new.nasbawan.de5.net",
      "new.xiaoming.uno",
      "new.xiaomingg.online",
      "new.xinjianya.top",
      "newapi.kitakamis.online",
      "newapi.ntruck.top",
      "newapi.this52.cn",
      "novel.sonnet.net.cn",
      "odysseia.jnai2d9kgnbs6xzx5c.com",
      "ollama.com",
      "one.ocoolai.com",
      "open.bigmodel.cn",
      "opencode.ai",
      "openrouter.ai",
      "pioneer.ai",
      "pool.vertin.top",
      "qianfan.baidubce.com",
      "redemption.dpdns.org",
      "rncdn.tonycola.online",
      "rouyashiki.co",
      "rouyashiki.zeabur.app",
      "ruoyun.icu",
      "share.inliver.com",
      "short-trip.cc.cd",
      "site.atopes.de",
      "ssvip.dmxapi.com",
      "stapi.cc.cd",
      "sub2api.214769.icu",
      "sub2api.us.ci",
      "sunlea.de",
      "te.bufan.live",
      "text.pollinations.ai",
      "token-plan-cn.xiaomimimo.com",
      "token-plan-sgp.xiaomimimo.com",
      "token.sensenova.cn",
      "tokendance.space",
      "tokenhub.tencentmaas.com",
      "tokenrhythm.studio",
      "uni.vertin.top",
      "vertin.top",
      "vidgen.x.ai",
      "www.aiping.cn",
      "www.dmxapi.cn",
      "www.dmxapi.com",
      "www.llmgame.xyz",
      "www.lmproxy.de5.net",
      "xlfyt.xyz",
      "xmapi.cc.cd",
      "youzi.today",
      "yuqing-suluokk.com",
      "zenmux.ai",
      "zyraonline.org"
    ],
    "allowedHostSuffixes": [".openai.azure.com"],
    "blockedHosts": [
      "030.zhufengmiao.top",
      "1.12.75.166",
      "107.158.36.238",
      "110.42.36.66",
      "152.53.166.72",
      "154.201.74.199",
      "154.21.84.25",
      "154.219.121.96",
      "165.99.42.14",
      "170.106.152.118",
      "2api.novai.su",
      "31.57.63.111",
      "38.175.200.23",
      "38.175.203.28",
      "38.246.251.165",
      "4.0.wokaai.com",
      "43.154.10.246",
      "43.161.249.15",
      "43.249.193.163",
      "47.6kd.top",
      "68886868.xyz",
      "89.116.246.146",
      "89.116.44.131",
      "992236.xyz",
      "ag.beijixingxing.com",
      "ai-free-api.kingo.dpdns.org",
      "ai.da520.online",
      "ai.dianhuomao.shop",
      "ai.iisbo.com",
      "ai.juguang.chat",
      "ai.liaobots.work",
      "ai.nyabit.com",
      "ai.seemstars.com",
      "ai.shuaihong.fun",
      "ai.tuiwen.xyz",
      "aiapi.yuejie.ltd",
      "aicanapi.com",
      "aixw.top",
      "api-666.cc",
      "api-cn.ttk.homes",
      "api.123chat.top",
      "api.242243.xyz",
      "api.5202030.xyz",
      "api.aabao.top",
      "api.aisaibasi.icu",
      "api.aixoras.com",
      "api.akane.win",
      "api.anay.asia",
      "api.apib.ai",
      "api.apicore.ai",
      "api.cervus.top",
      "api.chataiapi.com",
      "api.chenmoai.cn",
      "api.chienkjapi.mom",
      "api.chr1.com",
      "api.chr6.com",
      "api.claude-plus.top",
      "api.code-relay.com",
      "api.cyberclaude.com",
      "api.daidaibird.top",
      "api.dzzi.ai",
      "api.evopower.net",
      "api.fate86.cn",
      "api.flyupai.com",
      "api.fufuapi.top",
      "api.fufuflower.top",
      "api.gemai.cc",
      "api.goodsupport.top",
      "api.heibaiwoof.com",
      "api.iamhc.cn",
      "api.idlecloud.cc",
      "api.jiuguan.art",
      "api.lanapi.top",
      "api.lhyb.dpdns.org",
      "api.lilichat.cc",
      "api.lyouth.de",
      "api.maowo.love",
      "api.meow61.my",
      "api.mkeai.com",
      "api.moleapi.com",
      "api.mttieeo.com",
      "api.neonfox.top",
      "api.ofox.ai",
      "api.ohmygpt.com",
      "api.onechats.top",
      "api.onefly.ai",
      "api.only-ai.win",
      "api.pisces.ink",
      "api.qhaigc.net",
      "api.qiandao.mom",
      "api.qiyiguo.uk",
      "api.ricardochat.cn",
      "api.runapi.cfd",
      "api.shuixian.love",
      "api.sikong.shop",
      "api.silra.cn",
      "api.strai.site",
      "api.strai.top",
      "api.supxh.xin",
      "api.tcqnz.xyz",
      "api.tiu.me",
      "api.tokenrai.com",
      "api.tryallai.com",
      "api.ttk.homes",
      "api.uglycat.cc",
      "api.usora.jp",
      "api.vectorengine.ai",
      "api.vsllm.com",
      "api.vveai.com",
      "api.wangwangyou.cn",
      "api.wasdxx.xyz",
      "api.wulikk.click",
      "api.xiaocaseai.com",
      "api.xiaoen.baby",
      "api.xiaor.online",
      "api.xiaoxinapi.com",
      "api.xiaweiliang.cn",
      "api.yousebaby.com",
      "api.yuegle.com",
      "api.yunwu.ai",
      "api2.qiandao.mom",
      "api2.sllt.uk",
      "api520.pro",
      "api521.pro",
      "apis.sonetto.top",
      "azhexing.com",
      "binapi.shop",
      "binapi.space",
      "blog.tuiwen.xyz",
      "bnwu.top",
      "bnwum.com",
      "ca.bt6.top",
      "capi.cntest.us",
      "cat.beijixingxing.com",
      "cc.cwapi.vip",
      "cc.zaizai.pet",
      "chatapii.com",
      "chitang.xin",
      "ci.cwapi.me",
      "dash.242243.xyz",
      "ehco.sillydream.top",
      "enjoy.aigroks.org",
      "enjoydirect.ainewserver.com",
      "f.sillydream.top",
      "free-api.akane.win",
      "frpclient05.xhyonline.com",
      "gemini.beijixingxing.com",
      "geminiapi.top",
      "gg.aionline.fun",
      "gingfeng.sllt.uk",
      "globalai.vip",
      "go-model.com",
      "gomodel.tavernnn.com",
      "gptgod.online",
      "gy.jiubanai.com",
      "hiapi.online",
      "hyapi-new.zmeng.xyz",
      "i.klmai.xin",
      "iai.iisbo.com",
      "keyanci.top",
      "laopo.xin",
      "learn-ai.top",
      "liangjiewis.com",
      "liaobots.work",
      "linapi.net",
      "linkapi.cc",
      "liu-api.fun",
      "love.qinyan.icu",
      "max.brother99.top",
      "max.openai365.top",
      "metahk.zenymes.com",
      "metamrb.zenymes.com",
      "nekoapi.com",
      "new.12ai.org",
      "new.api-kk.shop",
      "new.wuxuai.com",
      "new.xfxai.top",
      "new.xiaweiliang.cn",
      "new2.sonetto.top",
      "newapi.aigchat.top",
      "newapi.ashesb.com",
      "newapi.sisuo.de",
      "newapi.zhibisora.top",
      "newcishu.zeabur.app",
      "nova.cervus.cn",
      "nova.cervus.top",
      "ohhapi.zeabur.app",
      "okapi.pockgo.com",
      "once-cf.novai.su",
      "once.novai.su",
      "one2.ayi11.com",
      "openai.chatnewai.com",
      "openai.newbotai.cn",
      "openai.sharkmagic.top",
      "privnode.com",
      "pro.chr1.com",
      "qingjiu.nemodesk.top",
      "qlbs.api.chengminya.cn",
      "qyapi.yzqyzl.cn",
      "sillytavern.goodsupport.top",
      "sllt.uk",
      "st.jove.life",
      "st.xfaigc.com",
      "superxiaoai.com",
      "tangguo.aicohere.org",
      "tb.api.mkeai.com",
      "tcdmx.com",
      "tokenrai.com",
      "twob.pp.ua",
      "us.novaiapi.com",
      "uuapi.net",
      "vg.v1api.cc",
      "want.eat99.top",
      "want.sillydream.top",
      "wish.sillydream.top",
      "ww1.rank100.top",
      "www.666ai.de",
      "www.baicai.chat",
      "www.cckff.ggff.net",
      "www.chataiapi.com",
      "www.ggwk1.online",
      "www.gpt4novel.com",
      "www.heibaiwoof.com",
      "www.jiemomiao.com",
      "www.jiemomo.com",
      "www.lemonapi.ai",
      "www.micuapi.ai",
      "www.redbox.ink",
      "www.tudou.chat",
      "www.wamwuai.com",
      "www.xiguaai6.com",
      "www.xyk29.top",
      "www.yxaiapp.com",
      "x-api.akane.win",
      "x.bbeioo.workers.dev",
      "xg.dianhuomao.shop",
      "xh.v1api.cc",
      "xiao-api.xyz",
      "xiaolanya.cn",
      "xiaor.xx.kg",
      "xn--api-9v2hp48c.cn",
      "yaojinzhi.icu",
      "yoiapi.com",
      "ys.mihoyo.com",
      "yukinoapi.com",
      "yunwu.ai",
      "yyds168.net"
    ]
  },
  "mortalOnly": {
    "blockedByUpstreamHosts": ["na.dslzl.top"]
  }
}
